import { User } from 'v2/models';

export type CompanyDetails = {
  display_name: string;
  website: string;
  name?: string;
  description?: string;
  industry?: string;
  location?: {
    locality?: string;
    region?: string;
    country?: string;
  };
};

export type CompanyDescriptions = {
  classification: string;
  long_description: string;
  short_description: string;
  vague_description: string;
};

export type CompanyDescriptionsResponse = {
  prompt_history_id?: number;
  content: CompanyDescriptions;
};

export const getTitle = (user: User) => {
  if (user.first_name || user.last_name) {
    return `${user.first_name || ''} ${user.last_name || ''}`.trim();
  } else {
    return user.email;
  }
};

export const buildCompanyDetailsPrompt = (externalCompany: CompanyDetails) => {
  const prompt = [
    '----- BEGIN COMPANY NAME CONTENT -----',
    externalCompany.display_name,
    '----- END COMPANY NAME CONTENT -----',
    '',
    '----- BEGIN COMPANY DESCRIPTION CONTENT -----',
    externalCompany.description,
    '----- END COMPANY DESCRIPTION CONTENT -----',
    '',
    '----- BEGIN COMPANY INDUSTRY CONTENT -----',
    externalCompany.industry,
    '----- END COMPANY INDUSTRY CONTENT -----',
    '',
    '----- BEGIN LOCATION OF THE COMPANY HEADQUARTERS CONTENT -----',
    `COUNTRY: ${externalCompany.location?.country ?? ''}`,
    `REGION: ${externalCompany.location?.region ?? ''}`,
    `LOCALITY: ${externalCompany.location?.locality ?? ''}`,
    '----- END LOCATION OF THE COMPANY HEADQUARTERS CONTENT -----',
  ].join('\n');
  return prompt;
};

export const isValidLinkedinUrl = (url: string): boolean => {
  const linkedinUrlRegex =
    /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|pub)\/[\w-]+\/?$/i;
  return linkedinUrlRegex.test(url);
};
